<div class="container">
  <app-titulo>Seleção do Desengate</app-titulo>
  <app-subtitulo>
    Selecione um desengate para associar ao engate.
  </app-subtitulo>
  <div class="tabela">
    <app-tabela-form
      *ngIf="!loader && tableData.length"
      [data]="tableData"
      [columns]="tableColumns"
    ></app-tabela-form>
  </div>
  <div class="buttons">
    <app-botao
      text="Cancelar"
      color="#27272A"
      bgColor="#F8FAFC"
      border="1px solid #D1D5DB"
      (click)="onCancelar()"
    />
    <app-botao
      text="Confirmar"
      border="1px solid #D1D5DB"
      [bgColor]="!dataToEmit.length ? '#D1D5DB' : 'var(--primary-color)'"
      (click)="emitDesengate()"
      [disabled]="!dataToEmit.length"
    />
  </div>
</div>

<app-loader [isLoading]="loader"></app-loader>
